export const FormMode = {
  create: 'create',
  edit: 'edit',
  readonly: 'readonly',
};
